import { createContext, useContext } from "react";

import { type NotificationCenterContextValue } from "./NotificationCenter.types";

export const NotificationCenterContext =
  createContext<NotificationCenterContextValue | null>(null);

export const useNotificationCenter = () => {
  const ctx = useContext(NotificationCenterContext);

  if (!ctx) {
    throw new Error(
      "NotificationCenter compound components must be used inside <NotificationCenter>.",
    );
  }

  return ctx;
};
